import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=dff814b0&scoped=true&lang=pug"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=dff814b0&lang=scss&scoped=true"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=dff814b0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff814b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dff814b0')) {
      api.createRecord('dff814b0', component.options)
    } else {
      api.reload('dff814b0', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=dff814b0&scoped=true&lang=pug", function () {
      api.rerender('dff814b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/newYear2024/components/Carousel.vue"
export default component.exports